<div class="card card-default mt-3">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ayBe7TigQlQ" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.html